import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LogoIcon } from "@/assets/logo/union_ver1.svg?react";
import { ReactComponent as AudionIcon } from "@/assets/logo/logo_ver1.svg?react";
import {
  NavContainer,
  NavInner,
  LogoSection,
  RightSection,
  LoginButton,
  ContactButton,
} from "./styles";
import { Logo } from "styles/styles";
const MenuBar: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = (path: string): void => {
    navigate(path);
  };

  return (
    <NavContainer>
      <NavInner>
        <LogoSection>
          <Logo onClick={() => handleNavigate("/")}>
          <LogoIcon style={{ width: "29px", height: "28px" }} />
          <AudionIcon style={{ width: "77px", height: "19px" }} />
          </Logo>
        </LogoSection>
        <RightSection>
          <LoginButton onClick={() => handleNavigate("/login")}>
            시작하기
          </LoginButton>
          <ContactButton onClick={() => handleNavigate("/contact")}>
            문의하기
          </ContactButton>
        </RightSection>
      </NavInner>
    </NavContainer>
  );
};

export default MenuBar;
